import React from 'react';
import StickyMessage from '../../StickyMessage';
import HTMLMessage from '../../HtmlMessage';

interface ChatRenderPredictionAnswerProps {
  message: React.ComponentProps<typeof HTMLMessage>['message'];
}

const ChatRenderPredictionAnswer = function ({
  message,
}: ChatRenderPredictionAnswerProps) {
  return (
    <StickyMessage>
      <HTMLMessage message={message} />
    </StickyMessage>
  );
};

export default ChatRenderPredictionAnswer;
